import React from 'react'

const Eps = ({ viewBox }) => (
  <svg viewBox={viewBox}>
    <g>
      <rect x="41.545" y="44.885" fill="#E4EAF5" width="2.177" height="1.951" />
      <rect x="21.955" y="44.885" fill="#E4EAF5" width="2.176" height="1.951" />
      <path
        fill="#E4EAF5"
        d="M39.644,38.25c-0.032-0.064-0.062-0.13-0.087-0.196h-0.195C39.457,38.117,39.55,38.184,39.644,38.25z"
      />
      <path
        fill="#E4EAF5"
        d="M23.043,36.103c-0.6,0-1.088,0.438-1.088,0.976c0,0.539,0.488,0.976,1.088,0.976
		c0.601,0,1.089-0.437,1.089-0.976C24.131,36.54,23.644,36.103,23.043,36.103z"
      />
      <path
        fill="#E4EAF5"
        d="M26.121,38.054c-0.026,0.066-0.056,0.132-0.086,0.196c0.092-0.066,0.186-0.133,0.28-0.196H26.121z"
      />
      <path
        fill="#E4EAF5"
        d="M43.722,37.078c0-0.539-0.488-0.976-1.088-0.976c-0.601,0-1.089,0.437-1.089,0.976s0.488,0.976,1.089,0.976
		C43.233,38.054,43.722,37.617,43.722,37.078z"
      />
      <path
        fill="#E4EAF5"
        d="M45.898,11.708c-1.804,0-3.265-1.311-3.265-2.927V0H13.248c-1.803,0-3.265,1.31-3.265,2.927v6.831h27.208
		c1.204,0,2.177,0.874,2.177,1.95v13.661c0,1.078-0.973,1.951-2.177,1.951H9.983v26.345c0,1.617,1.462,2.929,3.265,2.929H52.43
		c1.802,0,3.264-1.312,3.264-2.929V11.708H45.898z M43.222,42.932h1.589c0.6,0,1.088,0.438,1.088,0.977v3.903
		c0,0.539-0.488,0.977-1.088,0.977h-4.354c-0.603,0-1.089-0.438-1.089-0.977v-3.903c0-0.539,0.486-0.977,1.089-0.977h0.452
		c-0.882-1.952-2.629-3.517-4.807-4.309v0.407c0,0.538-0.486,0.976-1.086,0.976h-4.354c-0.603,0-1.09-0.438-1.09-0.976v-0.407
		c-2.177,0.792-3.922,2.356-4.807,4.309h0.453c0.601,0,1.089,0.438,1.089,0.977v3.903c0,0.539-0.488,0.977-1.089,0.977h-4.354
		c-0.601,0-1.088-0.438-1.088-0.977v-3.903c0-0.539,0.487-0.977,1.088-0.977h1.59c0.409-1.164,1.059-2.238,1.895-3.173
		c-0.4,0.158-0.843,0.247-1.308,0.247c-1.8,0-3.265-1.313-3.265-2.928c0-1.615,1.465-2.927,3.265-2.927
		c1.42,0,2.629,0.814,3.078,1.951h3.452v-0.976c0-0.54,0.487-0.976,1.09-0.976h4.354c0.6,0,1.086,0.436,1.086,0.976v0.976h3.454
		c0.449-1.137,1.658-1.951,3.077-1.951c1.8,0,3.265,1.312,3.265,2.927c0,1.614-1.465,2.928-3.265,2.928
		c-0.466,0-0.906-0.089-1.307-0.247C42.163,40.693,42.812,41.768,43.222,42.932z"
      />
      <rect x="31.751" y="36.103" fill="#E4EAF5" width="2.177" height="1.951" />
    </g>
    <path
      fill="#D3DCEE"
      d="M45.8,11.708h9.796L42.534,0v8.781C42.534,10.397,43.995,11.708,45.8,11.708z"
    />
    <g>
      <path
        fill="#F2944C"
        d="M39.269,25.369V11.708c0-1.076-0.975-1.95-2.177-1.95H9.883H1.177C-0.025,9.758-1,10.632-1,11.708v13.661
		c0,1.078,0.975,1.951,2.177,1.951h8.706h27.209C38.294,27.32,39.269,26.447,39.269,25.369z M8.795,17.563
		c0.602,0,1.088,0.437,1.088,0.975c0,0.54-0.486,0.977-1.088,0.977H5.53v1.952h5.441c0.601,0,1.089,0.436,1.089,0.976
		c0,0.539-0.488,0.976-1.089,0.976H5.53c-1.2,0-2.177-0.876-2.177-1.951v-5.854c0-1.076,0.977-1.952,2.177-1.952h5.441
		c0.601,0,1.089,0.437,1.089,0.976c0,0.54-0.488,0.977-1.089,0.977H5.53v1.951H8.795L8.795,17.563z M20.224,20.49h-3.81v1.952
		c0,0.539-0.487,0.976-1.089,0.976s-1.088-0.437-1.088-0.976v-7.807c0-0.539,0.486-0.977,1.088-0.977h4.897
		c2.101,0,3.81,1.533,3.81,3.416S22.323,20.49,20.224,20.49z M31.649,23.418h-5.44c-0.602,0-1.089-0.437-1.089-0.976
		c0-0.54,0.487-0.977,1.089-0.977h5.44c0.601,0,1.091-0.438,1.091-0.976c0-0.539-0.49-0.976-1.091-0.976h-3.264
		c-1.801,0-3.266-1.313-3.266-2.927c0-1.615,1.465-2.929,3.266-2.929h4.353c0.602,0,1.089,0.438,1.089,0.977
		s-0.487,0.977-1.089,0.977h-4.353c-0.601,0-1.089,0.437-1.089,0.976c0,0.538,0.488,0.976,1.089,0.976h3.264
		c1.801,0,3.266,1.312,3.266,2.927S33.45,23.418,31.649,23.418z"
      />
      <path
        fill="#F2944C"
        d="M20.224,15.612h-3.81v2.926h3.81c0.899,0,1.632-0.655,1.632-1.462
		C21.855,16.268,21.123,15.612,20.224,15.612z"
      />
    </g>
    <g>
      <path
        fill="#FFFFFF"
        d="M20.224,13.66h-4.898c-0.601,0-1.088,0.437-1.088,0.976v7.807c0,0.539,0.487,0.976,1.088,0.976
		c0.602,0,1.089-0.437,1.089-0.976V20.49h3.81c2.1,0,3.809-1.532,3.809-3.414C24.032,15.192,22.323,13.66,20.224,13.66z
		 M20.224,18.538h-3.81v-2.926h3.81c0.899,0,1.632,0.655,1.632,1.463S21.123,18.538,20.224,18.538z"
      />
      <path
        fill="#FFFFFF"
        d="M31.649,17.563h-3.264c-0.601,0-1.089-0.438-1.089-0.976c0-0.539,0.488-0.976,1.089-0.976h4.353
		c0.602,0,1.089-0.437,1.089-0.977c0-0.539-0.487-0.977-1.089-0.977h-4.353c-1.801,0-3.266,1.313-3.266,2.929
		c0,1.613,1.465,2.927,3.266,2.927h3.264c0.601,0,1.091,0.438,1.091,0.976s-0.49,0.977-1.091,0.977h-5.44
		c-0.602,0-1.089,0.436-1.089,0.976c0,0.539,0.487,0.976,1.089,0.976h5.44c1.801,0,3.266-1.313,3.266-2.928
		C34.915,18.877,33.45,17.563,31.649,17.563z"
      />
      <path
        fill="#FFFFFF"
        d="M10.972,15.612c0.601,0,1.089-0.437,1.089-0.977c0-0.539-0.488-0.977-1.089-0.977H5.53
		c-1.2,0-2.177,0.876-2.177,1.953v5.854c0,1.076,0.977,1.952,2.177,1.952h5.441c0.601,0,1.089-0.437,1.089-0.977
		c0-0.539-0.488-0.976-1.089-0.976H5.53v-1.951h3.265c0.602,0,1.088-0.437,1.088-0.977c0-0.538-0.486-0.975-1.088-0.975H5.53v-1.951
		H10.972L10.972,15.612z"
      />
    </g>
    <path
      fill="#F2944C"
      d="M45.8,37.078c0-1.615-1.465-2.927-3.266-2.927c-1.419,0-2.628,0.814-3.077,1.951h-3.452v-0.976
	c0-0.54-0.488-0.976-1.09-0.976h-4.353c-0.602,0-1.089,0.436-1.089,0.976v0.976h-3.453c-0.449-1.137-1.658-1.951-3.076-1.951
	c-1.801,0-3.266,1.312-3.266,2.927c0,1.614,1.465,2.928,3.266,2.928c0.464,0,0.906-0.089,1.307-0.247
	c-0.837,0.935-1.486,2.009-1.896,3.173h-1.589c-0.601,0-1.088,0.438-1.088,0.977v3.903c0,0.539,0.487,0.977,1.088,0.977h4.354
	c0.602,0,1.089-0.438,1.089-0.977v-3.903c0-0.539-0.487-0.977-1.089-0.977h-0.453c0.885-1.952,2.63-3.517,4.807-4.309v0.407
	c0,0.538,0.487,0.976,1.089,0.976h4.353c0.602,0,1.09-0.438,1.09-0.976v-0.407c2.176,0.792,3.921,2.356,4.805,4.309h-0.452
	c-0.603,0-1.089,0.438-1.089,0.977v3.903c0,0.539,0.486,0.977,1.089,0.977h4.354c0.601,0,1.089-0.438,1.089-0.977v-3.903
	c0-0.539-0.488-0.977-1.089-0.977h-1.589c-0.41-1.164-1.059-2.238-1.896-3.173c0.401,0.158,0.844,0.247,1.309,0.247
	C44.335,40.006,45.8,38.692,45.8,37.078z M24.032,46.836h-2.177v-1.951h2.177V46.836z M43.622,46.836h-2.178v-1.951h2.178V46.836z
	 M39.542,38.25c-0.09-0.066-0.187-0.133-0.28-0.196h0.193C39.481,38.12,39.511,38.186,39.542,38.25z M26.021,38.054h0.195
	c-0.095,0.063-0.189,0.13-0.281,0.196C25.966,38.186,25.995,38.12,26.021,38.054z M22.944,38.054c-0.601,0-1.089-0.437-1.089-0.976
	s0.488-0.976,1.089-0.976c0.6,0,1.088,0.437,1.088,0.976S23.544,38.054,22.944,38.054z M33.827,38.054h-2.178v-1.951h2.178V38.054
	L33.827,38.054z M41.445,37.078c0-0.539,0.488-0.976,1.089-0.976c0.6,0,1.088,0.437,1.088,0.976s-0.488,0.976-1.088,0.976
	C41.934,38.054,41.445,37.617,41.445,37.078z"
    />
  </svg>
)

export default Eps



// WEBPACK FOOTER //
// ./src/components/Svg/eps.js